export type ProjectStatus = 'Completed' | 'Draft' | 'Cancelled By Administator' | 'Failed';

export const ProjectStatusValues: Record<ProjectStatus, ProjectStatus> = {
    Completed: 'Completed',
    Draft: 'Draft',
    'Cancelled By Administator': 'Cancelled By Administator',
    Failed: 'Failed',
};

export interface Project {
    id: string;
    name: string;
    createDate: string;
    userId: string;
    animationModeId?: string;
    genreId?: string;
    resolutionId: string;
    projectStatusId: string;
    generativeVideoIntegrationId?: string;
    audioSynchronizationId?: string;
    width: number;
    height: number;
    framesPerSeconds?: number;
    smoothness?: number;
    positiveKeyword?: string;
    negativeKeyword?: string;
    translation: unknown[];
    rotation: unknown[];
    dynamicCamera?: unknown;
    oscillation?: unknown;
    intensity?: unknown;
    useWatermark?: boolean;
    captionPosition?: string;
    audio: {
        action: number;
        tempFileId: string;
        filename: string;
        url: string;
        hasValue: boolean;
        isEmpty: boolean;
        itemId: string;
    };
    completedForm?: { url: string };
    video?: { url: string };
    status: ProjectStatus;
    minutes: number;
    isSubmitted: boolean;
    userName: string;
    completedPercentage: number;
}
